class HomepageOurProjects {
	static block_name = "b-homepage-our-projects";

	constructor($elem) {
		this.$elem = $elem;
	}

	onInit() {
		const it = this;

		const $tabs = it.$elem.find(`.${HomepageOurProjects.block_name}__tabs`);
		const $tabs_content = it.$elem.find(`.${HomepageOurProjects.block_name}__tabs-content`);

		$tabs.find(`.${HomepageOurProjects.block_name}__tab`).click(function() {
			$(this).siblings().removeClass('active');
			$(this).addClass('active');
			var idx = $(this).index();
			$tabs_content.find(`.${HomepageOurProjects.block_name}__tab-content:not(:eq(`+idx+`))`).removeClass('active');
			$tabs_content.find(`.${HomepageOurProjects.block_name}__tab-content:eq(`+idx+`)`).addClass('active');
		});

		$tabs_content.find(`.${HomepageOurProjects.block_name}__tab-content-head`).click(function() {
			var $tab_content = $(this).closest(`.${HomepageOurProjects.block_name}__tab-content`);
			var idx = $tab_content.index();

			$tab_content.toggleClass('mob-active');

			if ($tab_content.hasClass('mob-active')) {
				$tabs.find(`.${HomepageOurProjects.block_name}__tab:eq(` + idx + `)`).addClass('mob-active');

				var top = $(this).parent().offset().top;

				if (top < $(window).scrollTop()) {
					$('html, body').stop().animate({
						scrollTop: $(this).parent().offset().top - 20
					}, 100, 'linear');
				}
			} else {
				$tabs.find(`.${HomepageOurProjects.block_name}__tab:eq(` + idx + `)`).removeClass('mob-active');
			}
		});

		it.calcHeightContent();

		$(window).resize(function () {
			it.calcHeightContent();
		});

	}

	calcHeightContent() {
		const it = this;

		const $tabs_content = it.$elem.find(`.${HomepageOurProjects.block_name}__tabs-content`);
		const $tabs_content_items = $tabs_content.find(`.${HomepageOurProjects.block_name}__tab-content`);
		const $tabs_content_heads = $tabs_content.find(`.${HomepageOurProjects.block_name}__tab-content-head`);

		let breakpoint = window.matchMedia('(min-width: 1200px)');
		if (breakpoint.matches) {

			var max_height = 0;

			$tabs_content_heads.css('min-height', 'auto');

			$tabs_content_items.addClass('calc');
			$tabs_content_items.each(function() {
				if (max_height < $(this).outerHeight()) {
					max_height = $(this).outerHeight(true);
				}
			});
			max_height += 4; // border
			$tabs_content_items.removeClass('calc');
			$tabs_content.css('min-height', max_height);

		} else {
			var max_height = 60;
			let breakpoint2 = window.matchMedia('(min-width: 768px)');

			if (breakpoint2.matches) {
				max_height = 90;
			}

			$tabs_content.css('min-height', 'auto');

			// calc mobile headers height
			$tabs_content_heads.css('min-height', 'auto');
			$tabs_content_heads.each(function() {
				if (max_height < $(this).outerHeight()) {
					max_height = $(this).outerHeight(true);
				}
			});
			$tabs_content_heads.css('min-height', max_height);
		}
	}
}

export default HomepageOurProjects;
